import React from 'react'
import Header from '../../Components/Header/Header'
import Footer from '../../Components/Footer/Footer'
import CustomerQueriesComponent from '../../Components/CustomerQueriesComponent/CustomerQueriesComponent'

const CustomerQueries = () => {
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Header/>
      <CustomerQueriesComponent/>
      <Footer/>
    </div>
  )
}

export default CustomerQueries
